import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addProfileImage, login, userlogout } from "../redux/userSlice";
import { resetTheme } from "../redux/themeSlice";
import LoaderModal from "../components/ModalLoader/LoaderModal";

const LoginDefaultPassword = () => {
  const dispatch = useDispatch();
  const { emailId, Urltoken } = useParams();

  // console.log("emailId : ", emailId);

  const [registerCheck, setRegisterCheck] = useState(false);

  // for loading modal ==>
    const [zapurl, setzapurl] = useState();
  const [errorStatus, setErrorStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;

  const naviagtion = useNavigate();

  const [defaultPassword, setDefaultPassword] = useState([]);
  const [changePasswordStatus, setChangePasswordStatus] = useState(false);
  const [hasCheckedRegistration, setHasCheckedRegistration] = useState(false);
  const [hasLoggedIn, setHasLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);

  const getAllDocuSign = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-docusign`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            
          },
        }
      );
      if (response.status === 200) {
        console.log(
          "resposne get all docusign list ",
          response?.data?.response[0]
        );
       
        setzapurl(response?.data?.response[0].zapurl);

        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };




  const fetchDefaultpasword = async () => {
    dispatch(userlogout());
    dispatch(resetTheme());
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/admin/Show-Default-Password`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setDefaultPassword(response?.data?.response?.password);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  useEffect(() => {
    fetchDefaultpasword();
    getAllDocuSign();
  }, []);

  // Email validation schema
  const emailValidationSchema = Yup.string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email domain must be a valid domain"
    );

  // Validate emailId on component mount
  useEffect(() => {
    emailValidationSchema
      .validate(emailId)
      .then(() => {
        setIsEmailValid(true);
      })
      .catch(() => {
        toast.error("Invalid email format. Please check the email ID.");
        setIsEmailValid(false); // Email is invalid
      });
  }, [emailId]);
  useEffect(() => {
    if (isEmailValid) {
      console.log("isEmailValid", isEmailValid);
      if (defaultPassword.length > 0 && !hasCheckedRegistration) {
        onSubmitcheckRegistration();
        setHasCheckedRegistration(true); // Set to true after checking
      }
    }
  }, [isEmailValid, defaultPassword]);

  const onSubmitcheckRegistration = async () => {
    if (isLoading) return; // Prevent further calls if already loading
    setIsLoading(true);
    // console.log("values",values.userName)
    const email = emailId;
    // "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0"
    const token = Urltoken;
    //  "#accountModal".modal("hide");
    // isDeleted: true,
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/check-registration/${email}/${token}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("resposne", response.data.success);
      // console.log("message => ", response);
      if (response?.data.statusCode == 200) {
        if (response?.data.massege == "User Already exist.") {
          setShowModal(false);
          const ResponsePassword = response?.data?.response?.password;
          if (ResponsePassword == defaultPassword) {
            setChangePasswordStatus(true);
          } else {
            setChangePasswordStatus(false);
            checkMailSign(ResponsePassword);
            // loginApi(ResponsePassword);
          }
        } else if (response?.data.massege == "User registered successfully") {
          setShowModal(false);
          toast.success("User registered successfully");
          const ResponsePassword = response?.data?.response?.password;
          if (ResponsePassword == defaultPassword) {
            setChangePasswordStatus(true);
          } else {
            setChangePasswordStatus(false);
            // console.log("line no 86");

            // loginApi(ResponsePassword);
          }
        }
      }
    } catch (error) {
      if (error.response.status == 400) {
        if (
          error?.response?.data?.errorMassage[0] ==
          "Your Authentication is failed!!"
        ) {
          toast.error("Your Authentication is failed!!");
          setShowModal(false);
        } else {
          toast.error(error?.response?.data?.errorMassage[0]);
          setShowModal(false);
        }
      }
      setErrorStatus(true);
    }
    setIsLoading(false);
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    new_Password: "",
    confirm_Password: "",
  };

  const validationSchema = Yup.object({
    new_Password: Yup.string()
      .min(6, "New password must be at least 6 characters")
      .required("Newpassword is Required"),
    confirm_Password: Yup.string()
      .oneOf([Yup.ref("new_Password"), null], "Passwords must match")
      .required("Confirm Password is Required"),
    firstName: Yup.string()
      .min(1, "First Name must be at least 1 characters")
      .test(
        "no-spaces",
        "First Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("First Name is Required"),
    lastName: Yup.string()
      .min(1, "Last Name must be at least 1 characters")
      .test(
        "no-spaces",
        "Last Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("Last Name is Required"),
  });

  // changePassword onsubmit function
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const data = {
      email: emailId,
      password: values.new_Password,
      firstName: values.firstName,
      lastName: values.lastName,
      token: "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0",
    };

    // console.log("form values",data);

    try {
      const response = await axios.post(
        `${APi_Url}api/auth/reset-default-password`,
        JSON.stringify(data),
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("default Password response", response?.data);

      if (response?.data?.success == true) {
        toast.success("Successfully change password");
        setChangePasswordStatus(false);
        setRegisterCheck(true);
        if(zapurl){
        sendMailSignature(values);
        }
        else{
          adminUpdateEsignature(emailId)
        }
        // loginApi(values.new_Password);
      }
      resetForm();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };
 const adminUpdateEsignature = async (email) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/update-mail-esignature-for-admin/${email}`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            
          },
        }
      );
      console.log("resposne profile send-mail-esignature-for-admin", response.data);
      if ( response.data.statusCode == 200 && response.data.success==true) {
        // console.log("resposne profile ", response.data.response);
        // setUserData(response?.data?.response);
        toast.success(response.data.response);
        setShowModal(false);
      }
      else{
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };
  const sendMailSignature = async (values) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/send-mail-esignature/${emailId}/${values.firstName}/${values.lastName}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("default Password response", response?.data);

      if (response?.data?.success == true) {
        toast.success("Successfully change password");
        setChangePasswordStatus(false);
      }
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const checkMailSign = async (password) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/check-mail-esignature/${emailId}`,
        {},
        {
          headers: {
            Accept: "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            secure: false,
            changeOrigin: true,
          },
        }
      );

      if (response.data.statusCode == 200 && response.data.success == true) {
        // login api

        loginApi(password);
      } else {
        setRegisterCheck(true);
      }
    } catch (error) {
      console.error("Error ", error);
    }
  };
  const storeToken = (token) => {
    const tokenData = {
      value: token,
      timestamp: new Date().getTime(),
    };
    sessionStorage.setItem("token", JSON.stringify(tokenData));
  };

  const loginApi = async (Password) => {
    if (hasLoggedIn) return; // Prevent further login attempts

    setHasLoggedIn(true);
    dispatch(userlogout());
    dispatch(resetTheme());
    const logindata = {
      userName: emailId,
      password: Password,
    };
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/login`,
        JSON.stringify(logindata),
        {
          headers: {
            Accept: "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            secure: false,
            changeOrigin: true,
          },
        }
      );

      // console.log('Response:', response);
      // console.log('userDetails:', response.data.response.userDetails);
      // console.log('statsucode:', response.data.statusCode);
      const responseToken = response.data.response.token;
      const statusCode = response.data.statusCode;
      const userDetails = response.data.response.userDetails;
      // console.log("getusers",userDetails.getusers[0])
      if (statusCode === 200) {
        toast.success("Successfully Login");
        storeToken(responseToken);
        sessionStorage.setItem("userRole", userDetails.role);

        dispatch(
          login({
            user: {
              id: userDetails.userId,
              role: userDetails.role,
              userEmail: userDetails.userEmail,
              firstName: userDetails.getusers[0].firstName,
              lastName: userDetails.getusers[0].lastName,
              token: response.data.response.token,
            },
          })
        );
        dispatch(addProfileImage(userDetails.profileImageUrl));
        // dispatch(addAccountPriority('update'));
        setShowModal(false);
        if (userDetails.role == "Dev") {
          naviagtion("/dashboard");
        } else if (userDetails.role == "Admin") {
          naviagtion("/admin/user");
        }
      }
      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      if (error?.response?.data?.errorMassage[0]) {
        toast.error(error?.response?.data?.errorMassage[0]);
      }
    } finally {
      setShowModal(false);
    }
  };

  return (
    <>
      <section className="dashbordsect">
        {/* modal for change password start */}
        <div
          className={`modal fade inputmodal ${
            changePasswordStatus ? "show" : ""
          }`}
          aria-hidden="true"
          style={{ display: changePasswordStatus ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1>Change Password</h1>
              </div>
              <div className="modal-body">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ resetForm }) => (
                    <Form className="row needs-validation">
                      <div className="col-md-12">
                      
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            First Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="firstName"
                              name="firstName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="firstName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* Last name */}

                     
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Last Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="lastName"
                              name="lastName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* new password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            New password
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="password"
                              id="new_Password"
                              name="new_Password"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="new_Password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* confirm password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Confirm password
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="password"
                              id="confirm_Password"
                              name="confirm_Password"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="confirm_Password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <button className="btn kevlar_btn" type="submit">
                          Submit
                        </button>
                      </div>
                      {/* <div className="col-12">
                        <button
                          className="btn kevlar_btn"
                          type="button"
                          onClick={() => {
                            setChangePasswordStatus(false);
                            resetForm();
                          }}
                        >
                          Cancel
                        </button>
                      </div> */}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        {/* modal for change password end */}

        {/* modal for sign api start */}

        <div
          className={`modal fade inputmodal ${registerCheck ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: registerCheck ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h4 className="document-message">
                  You must have received an Email to {emailId}.<br /> Kindly check your email for a copy
                  of our Terms and Conditions. You need to accept the terms to
                  proceed ahead.<br /><br />
                  If you are unable to locate this email kindly
                  reach out to us at client.support@smarttradingblueprint.com
                </h4>
                <div className="col-12">
                  <button
                    className="btn kevlar_btn"
                    type="submit"
                    onClick={() => {
                      setRegisterCheck(false);
                      naviagtion("/");
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* modal for sign api end */}
        <LoaderModal show={showModal} />
      </section>
    </>
  );
};

export default LoginDefaultPassword;
